import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var Pill = function Pill(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      onClose = _ref.onClose,
      closeRight = _ref.closeRight,
      theme = _ref.theme,
      href = _ref.href,
      otherProps = _objectWithoutProperties(_ref, ["children", "tag", "onClose", "closeRight", "theme", "href"]);

  var close = !tag ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick(evt) {
      return onClose && onClose(evt);
    },
    className: "pill--remove"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon pill--icon"
  })) : null;
  var Element = href ? 'a' : 'div';
  var customProps = href ? _objectSpread(_objectSpread({}, otherProps), href ? {
    href: href
  } : {}) : otherProps;
  var className = classNames('pill', {
    'pill--gray': theme === 'gray',
    'pill--white': theme === 'white',
    'pill--close_left': close && !closeRight,
    'pill--close_right': close && closeRight
  });
  return /*#__PURE__*/React.createElement(Element, _extends({
    className: className
  }, customProps), !closeRight && close, /*#__PURE__*/React.createElement("span", null, children), closeRight && close);
};

Pill.displayName = "Pill";
Pill.propTypes = {
  tag: PropTypes.bool,
  closeRight: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  href: PropTypes.string,
  theme: PropTypes.oneOf(['gray', 'white', 'default'])
};
Pill.defaultProps = {
  tag: false,
  closeRight: false,
  onClose: null,
  theme: 'default',
  href: ''
};
export default Pill;